import "app/Instrumentation"; // Sentry initialization should be imported first
import React from "react";
import ReactDOM from "react-dom/client";
import "@mediamath/design-system-eng/dist/main.css";
import "styles/themes/t1next/theme.scss";
import "primeicons/primeicons.css";
// Register Calendar locales before any date picker renders. Deep import by design:
// this is a side-effect module with no exports to route through the barrel, and
// importing the barrel here would pull every component into the entry chunk.
import "design-system/utils/init";
import RootComponent from "app/Root";

const Root = RootComponent as () => React.JSX.Element;
const container = document.getElementById("root")!;
const root = ReactDOM.createRoot(container);
root.render(<Root />);
